import React, { createContext, useContext, useState, useEffect } from 'react';

const AdminContext = createContext();

export const useAdmin = () => {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error('useAdmin must be used within an AdminProvider');
  }
  return context;
};

export const AdminProvider = ({ children }) => {
  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem('admin-dark-mode');
    return saved ? JSON.parse(saved) : false;
  });

  const [settings, setSettings] = useState(() => {
    const saved = localStorage.getItem('admin-settings');
    return saved ? JSON.parse(saved) : {
      currency: 'QAR',
      currencySymbol: 'ر.ق',
      defaultCategory: 'new',
      defaultPlaceholderImage: 'https://via.placeholder.com/400',
      lowStockThreshold: 10,
    };
  });

  useEffect(() => {
    localStorage.setItem('admin-dark-mode', JSON.stringify(darkMode));
    document.documentElement.setAttribute('data-theme', darkMode ? 'dark' : 'light');
  }, [darkMode]);

  useEffect(() => {
    localStorage.setItem('admin-settings', JSON.stringify(settings));
  }, [settings]);

  const toggleDarkMode = () => {
    setDarkMode(prev => !prev);
  };

  const updateSettings = (newSettings) => {
    setSettings(prev => ({ ...prev, ...newSettings }));
  };

  return (
    <AdminContext.Provider value={{
      darkMode,
      toggleDarkMode,
      settings,
      updateSettings,
    }}>
      {children}
    </AdminContext.Provider>
  );
};










